
import { FC, useState } from 'react';
import Logo from '../base/Logo';
import { Link } from 'react-router-dom';

const Header: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <Logo />
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">홈</Link>
            <a href="#about" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">소개</a>
            <a href="#menu" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">메뉴</a>
            <a href="#location" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">위치</a>
            <a href="#reservation" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">예약</a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="flex flex-col space-y-3 pt-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer"
              >
                홈
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer"
              >
                소개
              </button>
              <button 
                onClick={() => scrollToSection('menu')}
                className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer"
              >
                메뉴
              </button>
              <button 
                onClick={() => scrollToSection('location')}
                className="text-gray-700 hover:text-red-600 font-medium transition-colors text-left cursor-pointer"
              >
                오시는 길
              </button>
              <button 
                onClick={() => scrollToSection('reservation')}
                className="bg-gradient-to-r from-red-600 to-blue-600 text-white px-6 py-2 rounded-full font-medium hover:shadow-lg transition-all text-center cursor-pointer"
              >
                예약하기
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
